import * as React from "react";
import { steppers } from "../../Resource/Contents";
import { Filter } from "./Filter";
import { ClientTypeSelection } from "./ClientTypeSelection";
import { CustomerType } from "../../../../../../../Wrap/Constants/Enums/Customer/CustomerType";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { IAddClientModel } from "../AddClientWizard";
import { UserStore } from "../../../../../Stroes/Variable";
import { JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser";
import AdviserSiteTagManager, {
    eventCategoryForGTM,
} from "../../../../../../Shared/Cookies/ChoicesCookie/AdviserSiteTagManager";

interface IClientTypeProps extends IProcessComponentProps {
    data: IAddClientModel;
}

interface IClientTypeState {}

export class ClientType extends ProcessComponent<IClientTypeProps, IClientTypeState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    private addEvent = new AdviserSiteTagManager().addEvent;

    componentDidMount() {
        this.addEvent({
            environment: {
                appType: "web",
                setting: "prod",
                timestamps: JsonDateParser.toJsonDateNoOffset(new Date()).toString(),
            },
            page: {
                pageUrl: window.location.pathname,
                pageTitle: `${document.title} - add new client - cliet type`,
            },
            user: {
                loginId: UserStore.getUserInfo()?.ClientId.toString(),
                internal: "yes",
            },
            event: "pageLoaded",
        });
    }

    isValid() {
        const data: IAddClientModel = this.props.data;
        let flag = super.isValid();
        if (!data?.Prospect?.OwnerAdviserId) {
            this.props.showErrorMsgPopUp(["Please select an adviser."], true);
            flag = false;
        }
        if (!data?.CustomerType) {
            this.props.showErrorMsgPopUp(["Please select a client type."], true);
            flag = false;
        }
        return flag;
    }
    render() {
        const { data, onChange } = this.props;
        const ownerAdviserId = data?.Prospect?.OwnerAdviserId;
        return (
            <>
                <h2>{steppers.clientTypeSelection}</h2>
                <Filter
                    data={data}
                    onFilterSelectionChange={(value) => onChange(value)}
                    onRef={(ref) => this.appendChild(ref)}
                    onChange={() => onChange()}
                    ReadWriteAccessAdviserOnly={true}
                />
                <ClientTypeSelection
                    data={this.props.data?.CustomerType}
                    onChange={(type: CustomerType) =>
                        this.props.onChange({
                            CustomerType: type,
                            Individual: { OwnerAdviserId: ownerAdviserId },
                            Organisation: { OwnerAdviserId: ownerAdviserId },
                        })
                    }
                    onRef={(ref) => this.appendChild(ref)}
                />
            </>
        );
    }
}
